import React from 'react'
import PropTypes from 'prop-types'

const NoQuestsMatchYourSearch = ({ text }) => (
  <div className="no-quests-match-container">
    <div className="no-quests-icon" />
    <div className="no-quests-text">{text}</div>
  </div>
)

NoQuestsMatchYourSearch.propTypes = {
  text: PropTypes.string.isRequired
}

export default NoQuestsMatchYourSearch



// WEBPACK FOOTER //
// ./src/components/mini/NoQuestsMatchYourSearch.js